exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2JE33yqMFJns0N{display:block;color:#fff;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Noto Sans,Ubuntu,Droid Sans,Helvetica Neue,sans-serif;font-weight:400;padding:12px 2px 12px 12px;justify-content:left;align-items:center}._2JE33yqMFJns0N._3Gv7tRm_IYrndd{display:flex;flex-direction:row}.x31xD7G164H2pU{box-shadow:0 1px 1px rgba(9,30,66,.25),0 0 0 1px rgba(9,30,66,.08)}._2u7YwB_mY4WMkn{display:flex}._2A4RdwI86CdSnt{color:#172b4d;flex-grow:1;width:100%;margin-top:7px;font-size:20px;font-weight:600}._2A4RdwI86CdSnt._1OyMtAx--eUhs3,._2A4RdwI86CdSnt._1OyMtAx--eUhs3 a{color:#fff}.Z0DxiEphIzgJRA{border-radius:3px}._1sNeoJo1KdceWT{align-self:flex-start;justify-self:right;cursor:pointer}._1WjDA1M5TQc6Fq{padding-right:6px;flex-grow:1;color:#172b4d;font-size:14px;line-height:24px}._1WjDA1M5TQc6Fq a{color:#172b4d}._1WjDA1M5TQc6Fq._1OyMtAx--eUhs3,._1WjDA1M5TQc6Fq._1OyMtAx--eUhs3 a{color:#fff}", ""]);

// exports
exports.locals = {
	"narrowBannerContainer": "_2JE33yqMFJns0N",
	"noHeader": "_3Gv7tRm_IYrndd",
	"bannerShadow": "x31xD7G164H2pU",
	"topRow": "_2u7YwB_mY4WMkn",
	"headerBody": "_2A4RdwI86CdSnt",
	"lightText": "_1OyMtAx--eUhs3",
	"roundedCorners": "Z0DxiEphIzgJRA",
	"closeButton": "_1sNeoJo1KdceWT",
	"textContent": "_1WjDA1M5TQc6Fq"
};